import { render, staticRenderFns } from "./trainingApplicationsView.vue?vue&type=template&id=20cb74ed"
import script from "./trainingApplicationsView.vue?vue&type=script&lang=js"
export * from "./trainingApplicationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports